module.exports = __webpack_public_path__ + "66627f1fae160317344f50e7ca646644.svg";